import { render } from "./Rule.vue?vue&type=template&id=a8bead78&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"

import "./Rule.vue?vue&type=style&index=0&id=a8bead78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8bead78"],['__file',"src/components/rules/Rule.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8bead78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8bead78', __exports__)) {
    api.reload('a8bead78', __exports__)
  }
  
  module.hot.accept("./Rule.vue?vue&type=template&id=a8bead78&scoped=true", () => {
    api.rerender('a8bead78', render)
  })

}


export default __exports__